import { Injectable, inject } from '@angular/core';

import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { PaymentsApiService } from '../api/payments.api.sevice';

@Injectable({
    providedIn: 'root',
})
export class CustomTranslateLoaderService implements TranslateLoader {
    paymentsApiService = inject(PaymentsApiService);

    getTranslation(_langCountry: string): Observable<any> {
        return this.getContent();
    }

    getContent(): Observable<{ [key: string]: string }> {
        return this.paymentsApiService.get('PaymentsApi/content?cashierType=QuickDeposit');
    }
}
